module.exports = __webpack_public_path__ + "img/canbadge-round-32mm-glitter.27e1f62e.png";